import React from "react";
import PropTypes from "prop-types";

import { Icon, Transition } from "semantic-ui-react";

function WorkspaceBanner({
  title,
  action,
  children,
  visible,
  dismissComponent,
  onClose,
  style,
}) {
  return (
    <React.Fragment>
      <Transition visible={visible} animation="fade down" duration={500}>
        <div data-test="workspace-banner">
          <div
            style={{
              background: "#5e6afe",
              color: "white",
              padding: "15px 40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              ...style,
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <div
                data-test="title-container"
                style={{
                  marginRight: "20px",
                  fontSize: "110%",
                  minWidth: "200px",
                }}
              >
                <b>{title}</b>
              </div>
              <div
                data-test="child-container"
                style={{ display: "flex", flexGrow: 1, alignItems: "center" }}
              >
                <div style={{ marginRight: "20px" }}>{children}</div>
                <div style={{ marginRight: "20px" }}>{action}</div>
              </div>
            </div>
            <div data-test="banner-dismiss-container">
              {dismissComponent || <Icon name="close" link onClick={onClose} />}
            </div>
          </div>
        </div>
      </Transition>
    </React.Fragment>
  );
}

WorkspaceBanner.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  dismissComponent: PropTypes.node,
};

WorkspaceBanner.defaultProps = {
  style: {},
  children: undefined,
  visible: false,
  title: "",
  action: undefined,
  onClose: () => {},
  dismissComponent: undefined,
};

export default WorkspaceBanner;
